<template lang="html">

  <section class="header" :show="show" :launched="launched" :ghost="ghost" :min="menuMin">

    <div class="header-top row-between">

      <span class="contenedor-button-menu row-start">

        <button class="button-menu column-center" @click="show = !show">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </button>

        <idioma></idioma>
        <a class="tienda-online" href="https://tienda.aldonzagourmet.com/" target="_blank"
          v-if="lang == 'es' && siteMex == false">{{ $t('home.intro.tienda') }}</a>
        <a class="tienda-online" v-if="siteMex == true" href="static/pdf/precios-aldonza-mexico.pdf" target="_blank"><span>{{
          $t('home.intro.tarifas') }}</span></a>
        <a class="tienda-online" href="https://www.amazon.com.mx/s?srs=120920513011&rh=p_89%3AALDONZA" target="_blank"
          v-if="siteMex == true">{{ $t('home.intro.tienda') }}</a>
      </span>

      <a @click="initHome">
        <img src="/static/img/logo.png" alt="">
      </a>

    </div>

    <div class="header-bottom column-center">

      <nav class="menu-options column-center" @click="closeMenu">

        <router-link to="/home"><span>{{ $t('vistas.inicio') }}</span></router-link>
        <router-link class="pre-sub" :to="$t('enlaces.la_tierra')"><span>{{ $t('vistas.la_finca')
            }}</span></router-link>
        <router-link class="sub" :to="$t('enlaces.la_bodega')"><span>{{ $t('vistas.la_bodega') }}</span></router-link>
        <router-link class="sub" :to="$t('enlaces.la_almanzara')"><span>{{ $t('vistas.la_almazara')
            }}</span></router-link>
        <router-link class="sub" :to="$t('enlaces.sala_azafran')"><span>{{ $t('vistas.sala_azafran')
            }}</span></router-link>
        <router-link class="sub -last" :to="$t('enlaces.queseria')"><span>{{ $t('vistas.queseria')
            }}</span></router-link>
        <router-link :to="$t('enlaces.productos')"><span>{{ $t('vistas.productos') }}</span></router-link>
        <router-link :to="$t('enlaces.vive_aldonza')"><span>{{ $t('vistas.experiencias') }}</span></router-link>
        <a v-if="lang == 'es' && siteMex == false" href="https://tienda.aldonzagourmet.com/" target="_blank"><span>{{
          $t('home.intro.tienda') }}</span></a>


        <a href="https://blog.aldonzagourmet.com/" target="_blank"><span>{{ $t('vistas.blog') }}</span></a>
        <router-link class="contacto-pc" :to="$t('enlaces.contacto')"><span>{{ $t('vistas.contacto')
            }}</span></router-link>
        <a v-if="lang == 'es' || lang == 'en'" href="https://aldonza-gourmet.canales-eticos.com/#/" target="_blank"
          class="sub force" style="font-size: 36px;">
          <span>{{ $t('vistas.canal_etico') }}</span>
        </a>


      </nav>

      <rrss></rrss>



    </div>


  </section>

</template>

<script lang="js">

import { mapGetters, mapActions } from 'vuex';

import rrss from '@/components/parts/rrss'

import router from '@/router';

import idioma from '@/components/parts/idioma'

require('waypoints/lib/noframework.waypoints.js')

export default {
  name: 'app-header',
  data() {
    return {
      show: false,
      menuMin: false,
      siteMex: false
    }
  },
  mounted() {
    this.minMenu();
    this.waypoints();
    var that = this;
    $(window).scroll(function () {
      that.minMenu();
    })
    if (window.location.hostname.includes('.com.mx') ) {
      this.siteMex = true
    }
    if (this.$route.name != 'home') {

      if (!this.launched) {
        this.changeLaunched();
      }

    }


  },
  methods: {
    ...mapActions(['changeLaunched', 'setInitHome', 'changeGhostMenu']),
    closeMenu: function ($event) {
      this.show = false;
    },
    initHome: function () {
      if (this.$route.name != 'home') {
        router.push(this.texts.enlaces.home);
      } else {
        $('html, body').animate({
          scrollTop: 0
        }, 2000);
      }
    },
    minMenu: function () {
      let scrollTop = $(window).scrollTop();
      if (scrollTop >= ($(window).height() + 150)) {
        this.menuMin = true;
      } else {
        this.menuMin = false;
      }
    },
    waypoints: function () {
      var waypoints = document.getElementsByClassName('animation');
      for (var i = 0; i < waypoints.length; i++) {
        new Waypoint({
          element: waypoints[i],
          offset: '70%',
          handler: function () {
            this.element.classList.add("launched")
          }
        });
      }
    },
    procesothings: function () {
      console.log((this.$route.name.includes('proceso')));
      //Muestra y oculta el menú en función de si estas en la vista proceso o no
      (this.$route.name.includes('proceso')) ? this.changeGhostMenu(true) : this.changeGhostMenu(false);
    }
  },
  watch: {
    '$route': function () {

      this.show = false

      setTimeout(() => {
        this.waypoints();
      }, 100);


      if (this.$route.name == 'home') {

        if (!!this.$route.params.id) {

          let to = $("#" + this.$route.params.id).offset().top;

          console.log(to);

          (this.$route.params.id == 'blog') ? to -= 145 : to -= 72;

          $('html, body').animate({
            scrollTop: to
          }, 2000);

        } else {

          $('html, body').animate({
            scrollTop: 0
          }, 2000);


        }
      } else {

        // this.procesothings();

        if (!this.launched) {
          this.changeLaunched();
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      launched: 'isLaunchedHome',
      ghost: 'ghostMenu',
      texts: 'getTexts',
      lang: 'getLanguage'

    })
  },

  components: {
    'rrss': rrss,
    'idioma': idioma
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/colors.scss";

.tienda-online,
.tienda-online-menu {
  color: white;
  text-transform: uppercase;
  padding: 10px 20px;
  border: 1px solid white;
  border-radius: 18px;
  margin-left: 25px;
}

.header {
  position: fixed;
  width: 100%;
  display: inline-block;
  top: 0;
  left: 0;
  z-index: 28;

  &[imProceso=true] {
    display: none;
  }
}



.header[ghost="true"] {
  opacity: 0;
  pointer-events: none;
}


.header-top {
  width: 100%;
  padding: 15px 35px;
  z-index: 10;
  position: relative;
  transition: .5s;
}

.header[min="true"] .header-top {
  background: $plum;
  padding: 10px 35px;
}

.button-menu {
  width: 40px;
  height: 40px;
  border: none;
  outline: none;
  border: 1px solid white;
  background: transparent;
  cursor: pointer;
  transition: all .5s 1s;
  transform: translateY(-300px);
}

[launched=true] .button-menu {
  transform: translateY(0);
}


.button-menu span {
  width: 10px;
  height: 1px;
  transform: scaleX(0);
  display: inline-block;
  background: white;
  margin-bottom: 3px;
  /*transition: .5s;*/
  transition: transform 1s 2s;
}

[launched=true] .button-menu span {
  transform: scaleX(1);
}

.button-menu span:nth-child(1),
.button-menu span:nth-child(5) {
  width: 10px;
}

.button-menu span:nth-child(2),
.button-menu span:nth-child(4) {
  width: 14px;
}

.button-menu span:nth-child(3) {
  width: 18px;
}

.button-menu span:nth-child(5) {
  margin-bottom: 0;
}

[show=true] .button-menu span {
  opacity: 0;
}

[show=true] .button-menu span:nth-child(3) {
  opacity: 1;
}

.header-bottom {
  position: absolute;
  left: 0;
  top: -100vh;
  /*top: 0;*/
  height: 100vh;
  width: 100%;
  background: url("/static/img/fondo-menu.jpg") center/cover no-repeat;
  z-index: 9;
  will-change: transform;
  transition: .5s;
  overflow: hidden;
}


[show=true] .header-bottom {
  transform: translateY(100vh);
}


.header-bottom::before {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: url("/static/img/caballero-oscuro.png") 70% center no-repeat;
  content: '';
  opacity: 0;
  pointer-events: none;
  transition: .5s;
  transition-delay: .6s;
  will-change: filter opacity transform;
}

[show=true] .header-bottom::before {
  opacity: .6;
  transition: 2s;
  transition-delay: 0s;
}


.menu-options {
  margin-bottom: 7vh;
  position: relative;
  z-index: 2;
  width: 100%;
}

.menu-options a {
  padding-bottom: 40px;
  display: inline-block;
  position: relative;
  overflow: hidden;
  width: 100%;
}

.menu-options a span {
  color: white;
  font-size: 36px;
  font-family: 'Yeseva One', cursive;
  letter-spacing: 5px;
  display: inline-block;
  width: 100%;
  transition: .5s;
  will-change: transform;
  -webkit-font-smoothing: subpixel-antialiased;
  transform: translateZ(0);
  backface-visibility: hidden;
}

.menu-options a.force span {
  color: white !important;
  font-size: 36px !important;
  font-family: 'Yeseva One', cursive !important;
}

.menu-options a::before {
  width: 100px;
  bottom: 30px;
  height: 1px;
  background: white;
  display: inline-block;
  content: '';
  position: absolute;
  left: 50%;
  margin-left: -50px;
  transform: scaleX(0);
  transition: .5s;
  transition-delay: .5s;
}

.menu-options a::after {
  width: 1px;
  bottom: 15px;
  height: 15px;
  background: white;
  display: inline-block;
  content: '';
  position: absolute;
  left: 50%;
  margin-left: -1px;
  transform: scaleY(0);
  transform-origin: top;
  transition: .5s;
  transition-delay: 0s;
}

.menu-options a.pre-sub {
  padding-bottom: 10px;
}

.menu-options a.pre-sub::before,
.menu-options a.pre-sub::after {
  display: none;
}

.menu-options a.sub {
  padding-bottom: 00px;

  &.-last {
    padding-bottom: 40px;
  }
}

.menu-options a.sub span {
  font-size: 20px;
  padding-bottom: 10px;
  font-family: 'Montserrat', sans-serif;
}

.menu-options a.sub::after,
.menu-options a.sub::before {
  display: none;
}


.menu-options a.router-link-exact-active span {
  transform: scale(1.3);
}

.menu-options a.router-link-exact-active::after,
.menu-options a:hover::after {
  transform: scaleY(1);
  transition-delay: .5s;
}

.menu-options a:hover::before,
.menu-options a.router-link-exact-active::before {
  transform: scaleX(1);
}

.menu-options a.router-link-exact-active.pre-sub {
  padding-bottom: 40px;
}


.rrss {
  overflow: hidden;
  position: relative;
  z-index: 2;
}

.rrss a {
  width: 25px;
  height: 25px;
  margin: 0 5px;
  line-height: 25px;
  border-radius: 50%;
  border: 1px solid white;
  font-size: 14px;
  text-align: center;
  transform: translateY(150%);
  transition: .3s;
}

.menu-options .tienda-online-menu {
  width: auto;
  font-size: 22px;
  border-radius: 100px;
  padding: 15px 35px;
}

@for $i from 1 through 5 {
  [show=true] .rrss a:nth-child(#{$i}) {
    transition-delay: #{$i / 10 + .5}s;
  }
}


[show=true] .rrss a {
  transform: translateY(0%);
}


.otros-enlaces {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: -120px;
  padding: 0 35px;
  z-index: 2;
  transition: .4s;
  transition-delay: .8s;
}

[show=true] .otros-enlaces {
  transform: translateY(-140px);
}

.otros-enlaces a {
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 2px;
  margin-right: 15px;
}


.otros-enlaces a:last-of-type {
  margin-right: 0;
}


@media screen and (max-width: 1100px) {
  .header-top {
    padding: 10px 25px;

    img {
      max-width: 120px
    }
  }

  .header[min="true"] .header-top {
    padding: 10px 15px;
  }
}

@media screen and (max-width:895px) {
  .tienda-online {
    display: none
  }

}

@media screen and (max-width: 700px) {

  .menu-options {
    a {
      padding-bottom: 20px;

      &::before {
        bottom: 10px;
        width: 50px;
        margin-left: -25px;
      }

      &::after {
        display: none;
      }

      span {
        font-size: 18px;
      }
    }
  }

  .menu-options a.router-link-exact-active span {
    transform: scale(1.1);
  }

}

@media screen and (max-height: 800px) {


  .menu-options {
    margin-bottom: 30px;
  }

  .menu-options a,
  .menu-options a.sub.-last {
    padding-bottom: 5vh;
  }

  .menu-options a span {
    font-size: 20px;
  }
}


@media screen and (max-height: 500px) {


  .menu-options a,
  .menu-options a.sub.-last {
    padding-bottom: 3vh;
  }

  .menu-options a.sub span {
    font-size: 16px;
  }


}
</style>


// WEBPACK FOOTER //
// src/components/parts/header.vue